import { createFileRoute } from "@tanstack/react-router";
import { ChatRoomContent } from "@/features/chat/components/ChatRoomContent";
import { NotFoundPage } from "@/features/error-pages/components/NotFoundPage";

export const Route = createFileRoute("/chat-room/$chat-room-id")({
  component: ChatRoomContent,
  notFoundComponent: NotFoundPage,
  loader: ({ params }) => {
    return { chatRoomId: params["chat-room-id"] };
  },
  validateSearch: (search) => {
    return search as Record<string, unknown>;
  },
});
